import { BadgeCheckIcon, ChipIcon } from "@heroicons/react/solid";
import React from "react";
import { skills, technicalSkills } from "../data";
import { Grid, Collapse, Typography } from '@material-ui/core'
import { makeStyles } from "@material-ui/styles";
import { generalFormStyles } from './StyleObjects/generalStyles';
import { SkillCard } from './SkillCard';


const useFormStyles = makeStyles(generalFormStyles);

export function Skills() {
    const classes = useFormStyles();
    return (
        <Grid className={classes.skills}>
            <h1>TECHNICAL SKILLS</h1>
            <Grid item lg={3} xs={12} md={4} >
                <Grid container alignItems='center'>
                    <Grid container direction='row' className={classes.sampleBox}>
                        {technicalSkills.map((technicalSkill, index) => {
                            return(
                                <SkillCard technicalSkills={technicalSkill} />
                            );
                        })}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}